/**
 * CLE-3015 — mirrors `CURRICULUM_VERSION` in services/clear-api/src/domains/training/training.constants.ts.
 *
 * The API's value (GET /user/me/training → `curriculumVersion`) is the one that counts: saved progress
 * whose `version` differs from it is from an older curriculum, and the tour restarts from step 1. This
 * copy only lets the SPA notice a deploy skew (logged, never fatal). Bump both together.
 *
 * 2: per-module quizzes and the five-question knowledge check (John's review); version 1 progress has no
 * module state, so it restarts the tour.
 */
export const CURRICULUM_VERSION = 2;
